import { VStack, Spinner, Text } from '@cad-arc';
import { EventPanelMetadata, ReportingEventNumberDto } from '@mark43/cad-api';
import { SectionTitle } from '../../section-title';
import { RenDetails } from '../../../event-panel/tabs/event-details/components/helpers/ren-details';
import { useEventMetadataStore } from '../../../event-panel/event-panel-form/event-metadata';

export function ReportsSection({
    isLoading,
    reportingEventNumbers,
    agencyId,
}: {
    isLoading: boolean;
    reportingEventNumbers?: ReportingEventNumberDto[];
    agencyId?: number;
}) {
    const { eventId } = useEventMetadataStore()?.state?.metadata ?? ({} as EventPanelMetadata);

    if (isLoading) {
        return <Spinner />;
    }

    return (
        <VStack alignItems="flex-start" w="100%">
            <SectionTitle title="Reports" />
            {reportingEventNumbers?.length && agencyId ? (
                <RenDetails
                    eventId={eventId}
                    reportingEventNumbers={reportingEventNumbers}
                    agencyId={agencyId}
                />
            ) : (
                <Text fontSize="sm" color="tertiary">
                    --
                </Text>
            )}
        </VStack>
    );
}
